// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../Icon/IconV5.bs.js");
let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let ReactDatepicker = require("react-datepicker").default;
let JsxRuntime = require("react/jsx-runtime");

let Raw = {};

let defaultModifiers = {
  offset: {
    enabled: true,
    offset: "5, 10"
  },
  flip: {
    enabled: false
  }
};

function inputClassName(status) {
  if (status !== undefined) {
    if (status === "ok") {
      return "ok";
    } else {
      return "error";
    }
  } else {
    return "";
  }
}

let make = React.forwardRef((props, ref) => {
  let disabled = props.disabled;
  let onClick = props.onClick;
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let inputValue = Stdlib_Option.getOr(props.value, "");
  let match = inputClassName(props.status);
  let mergedClassName;
  let exit = 0;
  if (match === "" && className === "") {
    mergedClassName = "";
  } else {
    exit = 1;
  }
  if (exit === 1) {
    mergedClassName = className === "" ? match : (
        match === "" ? className : match + " " + className
      );
  }
  let clickHandler = disabled !== undefined ? (
      disabled || onClick === undefined ? undefined : onClick
    ) : (
      onClick !== undefined ? onClick : undefined
    );
  let tmp = inputValue === "" ? JsxRuntime.jsx(IconV5.make, {
      icon: "arrow-down",
      size: 16,
      className: "react-datepicker-custom-input-icon"
    }) : null;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("input", {
        ref: Stdlib_Option.map((ref == null) ? undefined : Primitive_option.some(ref), prim => prim),
        className: mergedClassName,
        disabled: disabled,
        placeholder: props.placeholderText,
        readOnly: true,
        value: inputValue
      }),
      tmp
    ],
    className: "tan-datepicker-custom-input",
    onClick: clickHandler
  });
});

let CustomInput = {
  make: make
};

function ReactDatepicker$1(props) {
  let disabled = props.disabled;
  let onChange = props.onChange;
  let __placeholderText = props.placeholderText;
  let placeholderText = __placeholderText !== undefined ? __placeholderText : "Select date...";
  let handleChange = value => {
    let date = Stdlib_Option.map((value == null) ? undefined : Primitive_option.some(value), CalendarDate.fromLocalDate);
    if (onChange !== undefined) {
      return onChange(date);
    }
  };
  return JsxRuntime.jsx(ReactDatepicker, {
    selected: Stdlib_Option.map(props.selected, CalendarDate.toLocalDate),
    onChange: handleChange,
    placeholderText: placeholderText,
    minDate: Stdlib_Option.map(props.minDate, CalendarDate.toLocalDate),
    maxDate: Stdlib_Option.map(props.maxDate, CalendarDate.toLocalDate),
    disabled: disabled,
    wrapperClassName: "tan-datepicker-wrapper",
    isClearable: true,
    popperPlacement: "bottom-start",
    popperModifiers: defaultModifiers,
    disabledKeyboardNavigation: true,
    calendarClassName: "tan-datepicker",
    popperClassName: "tan-datepicker-popper",
    customInput: JsxRuntime.jsx(make, {
      placeholderText: placeholderText,
      status: props.status,
      disabled: disabled
    })
  });
}

let make$1 = ReactDatepicker$1;

exports.Raw = Raw;
exports.defaultModifiers = defaultModifiers;
exports.inputClassName = inputClassName;
exports.CustomInput = CustomInput;
exports.make = make$1;
/* make Not a pure module */
